import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {OfferModel} from '../_models/offer.model';

@Injectable({providedIn: 'root'})

export class OffersDataService {
    constructor(private http: HttpClient) {
    }

    // Get All Offers
    getAllOffers() {
        return this.http.get('/agri/crm/allOffers');
    }

    // Filter Offers
    listOfferFilter(size, page, sort, orderDir, filterData: object) {
        return this.http.post<OfferModel>('agri/listOferFiltered?page=' + (page - 1) + '&size=' + size + '&sort=' + sort + '&dir=' + orderDir, filterData);
    }

    // View Offer
    viewSingleOffer(offerId: string) {
        return this.http.get<OfferModel>('/agri/crm/viewOffer?offerId=' + offerId);
    }

    // Create Offer
    createOffer(offerData: object) {
        return this.http.post('agri/crm/createOffer', offerData)
    }

    // Edit Offer
    editOffer(offerId: string, updatedData: object) {
        return this.http.put('agri/crm/updateOffer?offerId=' + offerId, updatedData)
    }

    // Get All Company
    getAllCompany() {
        return this.http.get('agri/crm/getAllCompanies')
    }

    // Create Contract By Offer
    createContractByOffer(offerId: string, offerData: object) {
        return this.http.post('agri/crm/createContractByOffer?offerId=' + offerId, offerData)
    }
}
